import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import { px2rem2 } from '@src/utils/rem-util';
import Store from './store';
const styles = require('./index.less');

const TabMenu = ({ store, className }) => {
  store.use();

  return (
    <div className={cx(styles.tabRoot, className)}>
      <span className={styles.decoLine} style={{ '--x': `${px2rem2((155 + 25) * store.activeIndex)}rem` }} />
      <span className={styles.decoArrow} />
      {store.tabList.map((item, index) => {
        return (
          <div
            className={cx(styles.tabItem, {
              [styles.active]: index === store.activeIndex
            })}
            key={index}
            onClick={() => store.handleTabChange(index, item)}
          >
            {item.tab_title}
          </div>
        );
      })}
    </div>
  );
};

export default wrapStore(TabMenu, Store);
